import React,{ useState, useEffect } from "react";
//import { Divider, Steps } from 'antd';

import { 
    ArrowDownOutlined,
    ArrowUpOutlined,
    LaptopOutlined
} from '@ant-design/icons';

function Upsells( { 
    cartData,
    id,
    //title,
    paymentReceived,
    setTvDrawerOpen,
    setInternetDrawerOpen,
    setPhoneDrawerOpen
} ) {

    let hasInternet = false;
    let hasTV = false;
    let hasPhone = false;
    let title = '';

    const getUpsellsTitle = () => {
        for( var i=0; i < cartData.length; i++ ) {
            if( cartData[i].product_cat == 'internet-packages' ) {
                hasInternet = true;
            }
    
            if( cartData[i].product_cat == 'tv-packages' ) {
                hasTV = true;
            }
    
            if( cartData[i].product_cat ==  'phone-packages' ) {
                hasPhone = true;
            }
        }

        return (( hasPhone && hasInternet && hasTV ) ? '' : 'Complete your package');


    }

    const getUpsellMarkup = () => {
        let upsellArray = [];

        for( var i=0; i < cartData.length; i++ ) {
            if( cartData[i].product_cat == 'internet-packages' ) {
                hasInternet = true;
            }
    
            if( cartData[i].product_cat == 'tv-packages' ) {
                hasTV = true;
            }
    
            if( cartData[i].product_cat ==  'phone-packages' ) {
                hasPhone = true;
            }
        }

        if( !hasInternet ) { 
            upsellArray.push(
                <>
                    <div className="upsell">
                        <div className="upsell-header">
                            Internet that's friendly
                        </div>
                        <div className="upsell-description">
                            With plans starting at just $45/month, it's easy to see what people are smiling about.
                        </div>
                        <button 
                            className="upsell-button change-info-button internet-package-check-availability-button"
                            onClick={handleAddInternetClick}>Add internet</button>
                    </div>
                    <hr/>
                </>
            );
        }

        if( !hasTV ) {
            upsellArray.push(
                <>
                    <div className="upsell">
                        <div className="upsell-header">
                            Start TV
                        </div>
                        <div className="upsell-description">
                            The channels you love, the features you want. The future of TV is here.
                        </div>
                        <div className="upsell-pricing-container">
                            <span>Plans starting at $10/mo</span>
                        </div>
                        <button className="upsell-button" onClick={handleUpsellTVCLick}>Add TV</button>
                    </div>
                    <hr/>
                </>
            );
        }

        if( !hasPhone ) {
            upsellArray.push(
                <>
                    <div className="upsell">
                        <div className="upsell-header">
                            Digital Home Phone
                        </div>
                        <div className="upsell-description">
                            Unlimited calling to 65 countries all across the globe, so you can stay close to your friends and family overseas.
                        </div>
                        <div className="upsell-pricing-container">
                            <span>Plans starting at $5/mo</span>
                        </div>
                        <button className="upsell-button" onClick={handleUpsellPhoneCLick}>Add Home Phone</button>
                    </div>
                </>
            );
        }

        return upsellArray;
    }

    const handleAddInternetClick = () =>{
        setInternetDrawerOpen( true );
    }

    const handleUpsellTVCLick = () =>{
        setTvDrawerOpen( true );
    }

    const handleUpsellPhoneCLick = () =>{
        setPhoneDrawerOpen( true );
    }

    return ( 
        <div 
            className={ `upsells-container` }
            style={{ display: ( paymentReceived ? 'none' : 'block' ) }}
            id={ id } >
                
            <div className='order-summary-h2'>
                { getUpsellsTitle() }
            </div>
            { getUpsellMarkup() }
        </div> 
    )
}

export default Upsells